declare global {
  interface Window {
    NeoAssistTagLoaded?: boolean;
    NeoAssistTag?: { pageid?: string; clientdomain?: string; querystring?: boolean };
    _NAWidgetLoaded?: unknown[];
  }
}

export const NEOASSIST_CLIENT_DOMAIN = 'agnes.neoassist.com';
export const NEOASSIST_CENTRAL_PATH = '/central-de-ajuda';
export const NEOASSIST_RESTORE_FLOATING_EVENT = 'neoassist:restore-floating';

// Central fixa (embed na /central-de-ajuda): prod usa a URL da pagina (document.location).
// Dev local: com VITE_NEOASSIST_DEV_URL preenchida, usa como `p` (localhost nao esta na
// allowlist); sem ela, cai no loader puro (localhost nao renderiza, mas nao quebra).
export function neoAssistCentralSrc(): string {
  const devUrl = import.meta.env.VITE_NEOASSIST_DEV_URL;
  if (!import.meta.env.DEV || !devUrl) return '//cdn.atendimen.to/n.js';
  const q = new URLSearchParams({
    ntag: '0',
    d: NEOASSIST_CLIENT_DOMAIN,
    i: '',
    p: devUrl,
    v: '202604',
  });
  return `https://cdn.atendimen.to/n.js?${q.toString()}`;
}

// FAB flutuante (app-wide): a regra da central flutuante no painel e 'compliance.<env>/'
// (raiz, match exato de path), entao fixa o p na raiz p/ casar em qualquer rota do SPA.
export function neoAssistWidgetSrc(): string {
  const q = new URLSearchParams({
    ntag: '0',
    d: NEOASSIST_CLIENT_DOMAIN,
    i: '',
    p: `${window.location.origin}/`,
    v: '202604',
  });
  return `https://cdn.atendimen.to/n.js?${q.toString()}`;
}
